import React, { createContext, useContext } from 'react';
import useGoogleMapsLoader from '../hooks/useGoogleMapsLoader';

const GoogleMapsContext = createContext();

export const useGoogleMaps = () => {
  const context = useContext(GoogleMapsContext);
  if (!context) {
    throw new Error('useGoogleMaps must be used within a GoogleMapsProvider');
  }
  return context;
};

export const GoogleMapsProvider = ({ children }) => {
  const { isLoaded, loadError, isLoading } = useGoogleMapsLoader();

  const value = {
    isLoaded,
    loadError,
    isLoading
  };

  return (
    <GoogleMapsContext.Provider value={value}>
      {children}
    </GoogleMapsContext.Provider>
  );
};
